import breakpoints from '@shared/styles/breakpoints.sass'
import { latestValue, yearMeanValue } from '@root/lib/valuesFromStation'

function sortMarkers ({ markers, selectedDataset }) {
  return selectedDataset === 'day'
    ? markers.sort((a, b) => latestValue(b) - latestValue(a))
    : markers.sort((a, b) => yearMeanValue(b) - yearMeanValue(a))
}

export const initialState = {
  markers: null,
  selectedMarkerIndex: null,
  selectedDataset: 'day',
  isOnSmallScreen: true,
  isTouchEnabled: false,
  visibleSchoolType: 'all'
}

export const actions = {
  setMarkers: (state, { markers }) => ({
    ...state,
    markers: sortMarkers({ markers, selectedDataset: state.selectedDataset })
  }),

  selectMarker: (state, { byIndex: index }) => ({ ...state, selectedMarkerIndex: index }),

  deselectMarker: (state) => ({ ...state, selectedMarkerIndex: null }),

  selectDataset: (state, { selectedValue: selectedDataset }) => {
    const selectedMarker = state.markers[state.selectedMarkerIndex]
    const resortedMarkers = sortMarkers({ markers: state.markers, selectedDataset })

    let newMarkerIndex = null
    if (state.selectedMarkerIndex !== null) {
      newMarkerIndex = state.markers.findIndex(marker => {
        return marker.properties.id === selectedMarker.properties.id
      })
    }

    return {
      ...state,
      selectedDataset,
      markers: resortedMarkers,
      selectedMarkerIndex: newMarkerIndex
    }
  },

  updateScreenType: (state, { screenWidth }) => ({
    ...state,
    isOnSmallScreen: screenWidth <= breakpoints.small
  }),

  storeThatTouchIsEnabled: (state) => ({
    ...state,
    isTouchEnabled: true
  })
}

export default { initialState, actions }
